export default "__VITE_ASSET__DvXh5BrN__"